import { administrations, authMenu, dashboardMenu, institutions, products } from 'menu';
import React, { lazy } from 'react';

const AUTH = {
	LOGIN: lazy(() => import('pages/presentation/auth/Login')),
	CONFIRMTFA: lazy(() => import('pages/presentation/auth/Confirm2Fa')),
	JOIN_TEAM: lazy(() => import('pages/presentation/auth/JoinTeam')),
	RESETGROUP: {
		FORGET_PASSWORD: lazy(() => import('pages/presentation/auth/Forget')),
		CONFIRM_RESET: lazy(() => import('../pages/presentation/auth/ConfirmForget')),
		RESET: lazy(() => import('../pages/presentation/auth/ResetPassword')),
	},
};

const LANDING = {
	PROFILE: lazy(() => import('pages/presentation/dashboard/Profile')),
	DASHBOARD: lazy(() => import('pages/presentation/dashboard/DashboardPage')),
	SYSTEM_API_KEYS: lazy(() => import('pages/presentation/dashboard/SystemApiKey/SystemApiKey')),
	SINGLE_SYSTEM_API_KEYS: lazy(
		() => import('pages/presentation/dashboard/SystemApiKey/SingleSystemApiKey'),
	),
	USERS: lazy(() => import('pages/presentation/dashboard/User/Users')),
	SINGLE_USER: lazy(() => import('pages/presentation/dashboard/User/SingleUser')),
	CUSTOMERS: lazy(() => import('pages/presentation/dashboard/Customer/Customers')),
	TRANSACTION: lazy(() => import('pages/presentation/dashboard/Transaction/Transactions')),
	SINGLE_TRANSACTION: lazy(
		() => import('pages/presentation/dashboard/Transaction/SingleTransaction'),
	),
	CURRENCIES: lazy(() => import('pages/presentation/dashboard/Currency/Currencies')),
	SINGLE_CURRENCY: lazy(() => import('pages/presentation/dashboard/Currency/SingleCurrency')),
	INVOICES: lazy(() => import('pages/presentation/dashboard/Invoices/Invoices')),
	SINGLE_INVOICE: lazy(() => import('pages/presentation/dashboard/Invoices/SingleInvoice')),
	WALLETS: lazy(() => import('pages/presentation/dashboard/Wallet/Wallets')),
	SINGLE_WALLET: lazy(() => import('pages/presentation/dashboard/Wallet/SingleWallet')),
};

const INSTITUTIONS = {
	COMPANIES: lazy(() => import('pages/presentation/institutions/Company/Companies')),
	SINGLE_COMPANY: lazy(() => import('pages/presentation/institutions/Company/SingleCompany')),
	PROJECTS: lazy(() => import('pages/presentation/institutions/Project/Projects')),
	SINGLE_PROJECT: lazy(() => import('pages/presentation/institutions/Project/SingleProject')),
	VERIFICATIONS: lazy(
		() => import('pages/presentation/institutions/Verification/IdentityVerifications'),
	),
	SINGLE_VERIFICATION: lazy(
		() => import('pages/presentation/institutions/Verification/SingleIdentityVerification'),
	),
};

const PRODUCTS = {
	PRODUCTS: lazy(() => import('pages/presentation/product/Product/Products')),
	SINGLE_PRODUCT: lazy(() => import('pages/presentation/product/Product/SingleProduct')),
	PLANS: lazy(() => import('pages/presentation/product/Plan/Plans')),
	SINGLE_PLAN: lazy(() => import('pages/presentation/product/Plan/SinglePlan')),
	CUSTOMER_PLANS: lazy(() => import('pages/presentation/product/CustomerPlan/CustomerPlans')),
	SINGLE_CUSTOMER_PLAN: lazy(
		() => import('pages/presentation/product/CustomerPlan/SingleCustomerPlan'),
	),
};

const ADMINISTRATION = {
	ROLES: lazy(() => import('pages/presentation/administrators/Role/Roles')),
	SINGLE_ROLE: lazy(() => import('pages/presentation/administrators/Role/SingleRole')),
	SINGLE_INVITE: lazy(() => import('pages/presentation/administrators/Admin/SingleInvite')),
	STAFF: lazy(() => import('pages/presentation/administrators/Admin/Administrators')),
	SINGLE_STAFF: lazy(() => import('pages/presentation/administrators/Admin/SingleTeam')),
};

const presentation = [
	/**
	 * AUTH
	 */
	{
		path: authMenu.login.path,
		element: <AUTH.LOGIN />,
		exact: true,
	},
	{
		path: authMenu.confirmLogin.path,
		element: <AUTH.CONFIRMTFA />,
		exact: true,
	},
	{
		path: `${authMenu.joinTeam.path}/:slug`,
		element: <AUTH.JOIN_TEAM />,
		exact: true,
	},
	{
		path: authMenu.forgetGroup.subMenu.forgetPassword.path,
		element: <AUTH.RESETGROUP.FORGET_PASSWORD />,
		exact: true,
	},
	{
		path: authMenu.forgetGroup.subMenu.confirmation.path,
		element: <AUTH.RESETGROUP.CONFIRM_RESET />,
		exact: true,
	},
	{
		path: authMenu.forgetGroup.subMenu.resetPassword.path,
		element: <AUTH.RESETGROUP.RESET />,
		exact: true,
	},
	/**
	 * DASHBOARD
	 */
	{
		path: authMenu.profile.path,
		element: <LANDING.PROFILE />,
		exact: true,
	},
	{
		path: dashboardMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
		exact: true,
	},
	{
		path: dashboardMenu.systemApiKeys.path,
		element: <LANDING.SYSTEM_API_KEYS />,
		exact: true,
	},
	{
		path: `${dashboardMenu.systemApiKeys.path}/:id`,
		element: <LANDING.SINGLE_SYSTEM_API_KEYS />,
		exact: true,
	},
	{
		path: dashboardMenu.systemApiKeys.path,
		element: <LANDING.SYSTEM_API_KEYS />,
		exact: true,
	},
	{
		path: dashboardMenu.users.path,
		element: <LANDING.USERS />,
		exact: true,
	},
	{
		path: `${dashboardMenu.users.path}/:id`,
		element: <LANDING.SINGLE_USER />,
		exact: true,
	},
	{
		path: dashboardMenu.customers.path,
		element: <LANDING.CUSTOMERS />,
		exact: true,
	},
	{
		path: dashboardMenu.transactions.path,
		element: <LANDING.TRANSACTION />,
		exact: true,
	},
	{
		path: `${dashboardMenu.transactions.path}/:id`,
		element: <LANDING.SINGLE_TRANSACTION />,
		exact: true,
	},
	{
		path: dashboardMenu.currencies.path,
		element: <LANDING.CURRENCIES />,
		exact: true,
	},
	{
		path: `${dashboardMenu.currencies.path}/:id`,
		element: <LANDING.SINGLE_CURRENCY />,
		exact: true,
	},
	{
		path: dashboardMenu.invoices.path,
		element: <LANDING.INVOICES />,
		exact: true,
	},
	{
		path: `${dashboardMenu.invoices.path}/:id`,
		element: <LANDING.SINGLE_INVOICE />,
		exact: true,
	},
	{
		path: dashboardMenu.wallets.path,
		element: <LANDING.WALLETS />,
		exact: true,
	},
	{
		path: `${dashboardMenu.wallets.path}/:id`,
		element: <LANDING.SINGLE_WALLET />,
		exact: true,
	},
	/**
	 * COMPANY
	 */
	{
		path: institutions.companies.path,
		element: <INSTITUTIONS.COMPANIES />,
		exact: true,
	},
	{
		path: `${institutions.companies.path}/:id`,
		element: <INSTITUTIONS.SINGLE_COMPANY />,
		exact: true,
	},
	{
		path: institutions.projects.path,
		element: <INSTITUTIONS.PROJECTS />,
		exact: true,
	},
	{
		path: `${institutions.projects.path}/:id`,
		element: <INSTITUTIONS.SINGLE_PROJECT />,
		exact: true,
	},
	{
		path: institutions.verifications.path,
		element: <INSTITUTIONS.VERIFICATIONS />,
		exact: true,
	},
	{
		path: `${institutions.verifications.path}/:id`,
		element: <INSTITUTIONS.SINGLE_VERIFICATION />,
		exact: true,
	},
	/**
	 * PRODUCTS
	 */
	{
		path: products.products.path,
		element: <PRODUCTS.PRODUCTS />,
		exact: true,
	},
	{
		path: `${products.products.path}/:id`,
		element: <PRODUCTS.SINGLE_PRODUCT />,
		exact: true,
	},
	{
		path: products.plan.path,
		element: <PRODUCTS.PLANS />,
		exact: true,
	},
	{
		path: `${products.plan.path}/:id`,
		element: <PRODUCTS.SINGLE_PLAN />,
		exact: true,
	},
	{
		path: products.customerPlans.path,
		element: <PRODUCTS.CUSTOMER_PLANS />,
		exact: true,
	},
	{
		path: `${products.customerPlans.path}/:id`,
		element: <PRODUCTS.SINGLE_CUSTOMER_PLAN />,
		exact: true,
	},
	/**
	 * ADMINISTRATION
	 */
	{
		path: administrations.roles.path,
		element: <ADMINISTRATION.ROLES />,
		exact: true,
	},
	{
		path: `${administrations.roles.path}/:id`,
		element: <ADMINISTRATION.SINGLE_ROLE />,
		exact: true,
	},
	{
		path: `${administrations.staff.path}/invites/:id`,
		element: <ADMINISTRATION.SINGLE_INVITE />,
		exact: true,
	},
	{
		path: administrations.staff.path,
		element: <ADMINISTRATION.STAFF />,
		exact: true,
	},
	{
		path: `${administrations.staff.path}/:id`,
		element: <ADMINISTRATION.SINGLE_STAFF />,
		exact: true,
	},
];
const contents = [...presentation];

export default contents;
